import React from 'react';
const links = [{
  label: 'AGB',
  href: '#agb'
}, {
  label: 'Datenschutz',
  href: '#datenschutz'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}, {
  label: 'Impressum',
  href: '#impressum'
}];
export function Footer() {
  return <footer className="bg-brand-navydeep px-4 py-12 text-center text-sm text-white/60" data-id="element-69" data-mp="32pff8bhdzhy6">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="36q9354utwwr2">
        <div className="flex items-center justify-center gap-2" data-id="element-71" data-mp="36n3bpiyq9is6">
          <span className="font-script text-2xl leading-none text-brand-orange" aria-hidden="true" data-id="element-72" data-mp="3ufjw405xtmun">
            𝄞
          </span>
          <span className="font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-73" data-mp="3levkfc40nykx">
            Musik Startklar
          </span>
        </div>
        <p className="mt-2 text-xs text-white/50" data-id="element-74" data-mp="3qfjfc8vd8zkf">
          Das komplette Musik-Curriculum
        </p>
        <nav aria-label="Rechtliches" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-75" data-mp="2a1jlnfn4665m">
          {links.map(link => <a key={link.label} href={link.href} className="transition-colors hover:text-white" data-id="element-76" data-mp="3la272nvdqrs2">
              {link.label}
            </a>)}
        </nav>
        <p data-id="element-77" data-mp="3v5deel4gkwps">© 2026 Musik Startklar. Alle Rechte vorbehalten.</p>
      </div>
    </footer>;
}